/**
 * Páginas abertas recentemente, por pessoa, para o atalho da página inicial.
 *
 * Fica só no navegador (localStorage), com a chave por e-mail: é uma conveniência, não um
 * dado do sistema. Se o armazenamento estiver indisponível (janela anônima, bloqueado), a
 * lista fica vazia e nada quebra.
 */
import { useEffect, useMemo } from 'react';

import { PAGINAS, rotaNova, type Pagina } from '../app/paginas';

export const MAX_RECENTES = 6;
const PREFIXO = 'perseverahub.recentes.';

function ler(email: string): string[] {
  try {
    const bruto = window.localStorage.getItem(PREFIXO + email);
    const lista: unknown = bruto ? JSON.parse(bruto) : [];
    return Array.isArray(lista) ? lista.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

/** Registra a página da rota (se for uma página do menu) no topo da lista. */
export function registrarVisita(email: string, pathname: string): void {
  const pagina = PAGINAS.find((p) => rotaNova(p) === pathname);
  if (!pagina) return;
  const lista = [pagina.slugLegado, ...ler(email).filter((s) => s !== pagina.slugLegado)];
  try {
    window.localStorage.setItem(PREFIXO + email, JSON.stringify(lista.slice(0, MAX_RECENTES)));
  } catch {
    // Armazenamento indisponível: segue sem guardar.
  }
}

/** Páginas recentes da pessoa, da mais recente para a mais antiga. */
export function paginasRecentes(email: string): Pagina[] {
  return ler(email)
    .map((slug) => PAGINAS.find((p) => p.slugLegado === slug))
    .filter((p): p is Pagina => !!p);
}

/** Registra cada troca de página (usado no Shell, que conhece o usuário). */
export function useRegistrarVisitas(email: string, pathname: string): void {
  useEffect(() => registrarVisita(email, pathname), [email, pathname]);
}

/** Lista atual, lida ao montar a página que a mostra. */
export function useRecentes(email: string | undefined): Pagina[] {
  return useMemo(() => (email ? paginasRecentes(email) : []), [email]);
}
